import React from "react";
import { HardHat, Hammer, Ruler, Zap } from "lucide-react";
import styles from "./PeopleSearchHero.module.scss";

type QuickSkill = {
  id: number;
  name: string;
};

type PeopleSearchHeroProps = {
  quickSkills: QuickSkill[];
  onSelectSkill: (skillId: number) => void;
};

const PeopleSearchHero = ({
  quickSkills,
  onSelectSkill,
}: PeopleSearchHeroProps) => {
  return (
    <section className={styles.hero}>
      <div className={styles.intro}>
        <h1 className={styles.title}>Encontrá el perfil perfecto para tu obra</h1>
        <p className={styles.subtitle}>
          Seleccioná una especialidad para comenzar o abrí los filtros y afiná tu búsqueda.
        </p>
      </div>
      {quickSkills.length > 0 && (
        <div className={styles.tiles}>
          {quickSkills.slice(0, 4).map((skill, index) => (
            <button
              key={skill.id}
              type="button"
              className={styles.tile}
              onClick={() => onSelectSkill(skill.id)}
            >
              <span className={styles.tileIcon}>
                {index === 0 && <HardHat size={14} />}
                {index === 1 && <Hammer size={14} />}
                {index === 2 && <Zap size={14} />}
                {index === 3 && <Ruler size={14} />}
              </span>
              <span className={styles.tileLabel}>{skill.name}</span>
            </button>
          ))}
        </div>
      )}
    </section>
  );
};

export default PeopleSearchHero;

